import { updateWidgetConfig } from '../../../helpers/configuration/actions';
import Definitions from '../../../../parent/features/logic/questionnaire-defs/Definitions';
import store from '../../../helpers/store';
import Logger from '../../../../common/logger';

const getDefinitionsDirURL = () => {
    const state = store.getState();

    if (!state.settings || !state.settings.features || !state.settings.features.features) {
        return null;
    }

    const questionnaireDefsFeature = state.settings.features.features.find(
        (f) => f.name === 'questionnaire-defs'
    );

    if (questionnaireDefsFeature && questionnaireDefsFeature.options) {
        return questionnaireDefsFeature.options.definitionsDirURL;
    }
    return null;
};

const getNewQuestionnaireDefinition = (questionnaireName) => {
    return new Promise((resolve) => {
        const definitionsDirURL = getDefinitionsDirURL();
        Definitions.load(
            definitionsDirURL,
            questionnaireName,
            (result) => {
                resolve(Definitions.postProcess(result));
            },
            () => {
                resolve(null);
            }
        );
    });
};

const getCurrentQuestionnaireDefinition = (target) => {
    const state = store.getState();
    if (state.config && state.config.widget && state.config.widget.questionnaireOptions) {
        const option = state.config.widget.questionnaireOptions.find((o) => o.target === target);
        return option && option.value ? option.value : null;
    }
    return null;
};

const SetQuestionnaireName = {
    name: 'setQuestionnaireName',
    exec: (customMessage) => {
        if (!customMessage.payload.parameter) {
            Logger.log('setQuestionnaireName: clearing questionnaire definitions');
            updateWidgetConfig({
                questionnaireOptions: []
            });
        } else {
            getNewQuestionnaireDefinition(customMessage.payload.parameter).then(
                (newQuestionnaireDefinition) => {
                    if (!newQuestionnaireDefinition) {
                        return;
                    }

                    const qAgentDefinition = getCurrentQuestionnaireDefinition('agent');
                    const qBotDefinition = getCurrentQuestionnaireDefinition('bot');
                    Logger.log('setQuestionnaireName: updating questionnaire definitions');
                    updateWidgetConfig({
                        questionnaireOptions: [
                            {
                                target: 'agent',
                                value: /_BOT$/.test(customMessage.payload.parameter)
                                    ? qAgentDefinition
                                    : newQuestionnaireDefinition
                            },
                            {
                                target: 'bot',
                                value: /_BOT$/.test(customMessage.payload.parameter)
                                    ? newQuestionnaireDefinition
                                    : qBotDefinition
                            }
                        ]
                    });
                }
            );
        }
    }
};

export default SetQuestionnaireName;
